"use client";

import { Grid2 } from "@repo/ui";
import Section from "../components/Section";
import CourseCard from "../components/CourseCard";

interface CourseTypes {
  coverSrc: string;
  tag: string;
  title: string;
  description: string;
  totalEnroll: string;
  ratings: string;
  topicsCovered: string;
  topics: string[];
  author: string;
  date: string;
  duration: string;
}

type GainSomeKnowledgeProps = {
  data: CourseTypes[];
};

const RecommendedBlog = ({ data }: GainSomeKnowledgeProps) => {
  return (
    <Section
      title="Recommended Blogs"
      className="bg-gradient-to-b from-blue-50 to-white"
    >
      <Grid2 container spacing={2}>
        {data.slice(0, 3).map((currentCourse, idx) => (
          <Grid2 key={idx} item xs={12} sm={12} md={4} lg={4}>
            <CourseCard {...currentCourse} key={idx} isAuthor />
          </Grid2>
        ))}
      </Grid2>
    </Section>
  );
};

export default RecommendedBlog;
